import { Outlet, useLocation } from 'react-router';

import { useAuthStore } from '@/auth/auth.store';
import { ErrorBoundary } from '@/components/ErrorBoundary';

import { Header } from './Header';
import { SIDEBAR_OFFSET_CLASS } from './layout.constants';
import { Sidebar } from './Sidebar';

export function AdminLayout() {
    const { identity } = useAuthStore();
    const location = useLocation();

    if (!identity) return null;

    return (
        <div className="min-h-screen">
            <Sidebar identity={identity} />
            <div className={SIDEBAR_OFFSET_CLASS}>
                <Header identity={identity} />
                <main className="p-6">
                    <ErrorBoundary resetKey={location.key}>
                        <Outlet />
                    </ErrorBoundary>
                </main>
            </div>
        </div>
    );
}
